export const ALL_FILTER_OPTION = {
  label: 'All',
  value: '',
};
